@if (isFile_()) {
	<div
		class="py-3"
		[ngClass]="isTitleCell() ? 'pl-6 pr-3' : 'pl-3 pr-6'"
		(mouseenter)="setShowViewDetails(true)"
		(mouseleave)="setShowViewDetails(false)"
	>
		<div class="relative">
			<div class="flex items-center gap-3 min-w-0">
				<div class="shrink-0">
					<img
						[src]="`/assets/images/client-portal/${answerIcon_()}.svg`"
						alt="icon"
						class="w-8 h-8"
					/>
				</div>
				<span
					#fileNameElement
					class="truncate min-w-0 flex-1"
					[matTooltip]="fileNameTooltip_()"
					[matTooltipShowDelay]="500"
				>
					{{ answerFile_()?.fileName }}
				</span>
			</div>

			@if (showViewDetails_()) {
				<div>
					<ui-button
						label="View"
						size="sm"
						icon="external-link"
						preset="EXTRA_LOW_EMPHASIS"
						class="absolute top-0 right-0"
						(click)="openFile()"
					></ui-button>
				</div>
			}
		</div>
	</div>
} @else {
	<div
		#textElement
		class="truncate grow-0 py-3"
		[ngClass]="isTitleCell() ? 'pl-6 pr-3' : 'pl-3 pr-6'"
	>
		<span [matTooltip]="textElementTooltip_()" [matTooltipShowDelay]="500">{{
			answerText_()
		}}</span>
	</div>
}
